import { IFilterSelectedCompany } from '@/bundles/GroupFilters/interfaces/inputs/IFilterSelectedCompany';

export const getCompanyMultipleSelectFormattedValue = (value: IFilterSelectedCompany[]) => {
  return value.map((company) => company.name).join(', ');
}
